import { Search } from 'lucide-react';
import CommonSearchInput from '../../common/CommonSearchInput';

const FaqFilter = ({ searchTerm, setSearchTerm }) => {
    return (
        <div className="bg-[#f8fafc] p-6 rounded-3xl border border-gray-100 shadow-sm">
            <div className="flex flex-col sm:flex-row justify-between gap-4">
                <CommonSearchInput
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="안전 수칙, 법령, 보호구 기준 등을 검색해 보세요."
                    icon={Search}
                    height="h-12"
                />
            </div>
        </div>
    );
};

export default FaqFilter;

